<template>
  <div id="myChart" style="width: 100%; height: 300px"></div>
</template>

<script>
export default {
  name: "Echarts",
  props: ["name","tableData","colAttr"],
  data() {
    return {
      xData: [],
      legendData: [],
      series:[],
      msg: "Welcome to kalacloud.com",
    };
  },
  mounted() {
    this.initData() 
    this.drawLine();
    console.log(this.tableData,this.colAttr);
  },
  methods: {
    initData() {
      let series = []
      this.tableData.forEach(v => {
      let tmp = []

        this.xData.push(v.date)
         
      });
    },
    drawLine() {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表

      myChart.setOption({
        title: {
          left: "center",
          text: this.name ? `全国多模式平均${this.name}日数历年变化`:'',
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["最大值", "最小值"],
          selector:'true',
          top: 40, //调整位置
          left: "38%", //调整位置
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData 
        },
        yAxis: {
          type: "value",
          
        },
        series: [
          {
            name: "最大值",
            type: "bar",
            // stack: "Total",
            data: [111, 444, 123, 78, 90, 24, 77,120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "最小值",
            type: "bar",
            // stack: "Total",
            data: [120, 132, 101, 134, 90, 230, 210,111, 444, 123, 78, 90, 24, 77],
          },
          
        ],
      });
    },
  },
};
</script>

<style>
</style>